/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Anhänge bekommen'
  },
  HEADER: {
    DATE: 'Datum',
    SENT_BY_F: 'Gesendet von',
    TITLE: 'Titel'
  },
  LABEL: {
    ATTACHMENTS: 'Anhänge',
    DATE: 'Datum',
    DETAIL: 'Detail',
    MESSAGE: 'Nachricht',
    NO_ROWS_COMMUNICATIONS: 'Keine Kommunikation',
    SENT_BY_F: 'Gesendet von',
    TITLE: 'Titel',
    UNREAD: 'Ungelesen'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
